module.exports = __webpack_public_path__ + "static/photography-ba9c7f6d3ea9780b630b022bdb747121.png";